// extracted by mini-css-extract-plugin
module.exports = {"swiper":"Swiper_swiper__x_JyD","image":"Swiper_image__InGeQ"};